import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate,Navigate } from "react-router-dom";
import { Buffer } from "buffer";
import { nanoid } from "nanoid";
import axios from "axios";

// Import supabase configuration
import supabase from "../config/supabase";

export function PrivateRoute({ children }) {
  const [checkClientType, setCheckClientType] = useState("");
  const [boardId, setBoardId] = useState("");
  const [activeLink, seTActiveLink] = useState(false);
  const [url, setUrl] = useState([]);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [renderFlag, setRenderFlag] = useState(false);
  const user = supabase.auth.user();

  const navigate = useNavigate();

  useEffect(async () => {
    var url = new URL(window.location.href);
    setUrl(url);
    
    var getValue = window.location.href.split("=")[2];
    let masked_url = window.location.href.split("redirect")[1]?.substring(1);

    if(masked_url?.length == 6){
      var { data, error } = await supabase
        .from("board_profiles")
        .select("*")
        .match({ masked_url: window.location.href });

        if(data && data.length > 0){
          setRedirectUrl(data[0].url);
          seTActiveLink(true);
        }
        else if (data && data.length <= 0){
          var { data, error } = await supabase
          .from("board_clients_invitation")
          .select("*")
          .match({ masked_url: window.location.href });

          if(data && data.length > 0){
            setRedirectUrl(data[0].url_with_token);
            seTActiveLink(true);
          }
        }
    }
    // Check before profile view rendering
    else if(getValue !== "true"){
      let get_id = url.searchParams.get("id") && url.searchParams.get("id").split("/")[0];
      let get_board_id = url.searchParams.get("board") && url.searchParams.get("board").split("/")[0];
      let token = url.searchParams.get("id") && url.searchParams.get("id").split("/")[1];

      let board_id = Buffer.from(get_id || get_board_id || "", "base64").toString("utf-8");
      setBoardId(board_id);

      // check if auth token is already in local storage
      var session_token = JSON.parse(localStorage.getItem("supabase.auth.token")) || '';
      let email =session_token && session_token.currentSession.user.email;

      // Remove client if client is private and already loggedIn in other tab
      if(email && !token && url.searchParams.get("id")){
        localStorage.removeItem("clientUrl");
      }
      let client = localStorage.getItem("clientUrl");
      // Check dashboard
      let dashboard = url.searchParams.get("dashboard");
      if(dashboard){
        seTActiveLink(true);
      }
      else if(token){
        const { data, error } = await supabase
          .from("board_clients_invitation")
          .select("*")
          .match({ url_with_token: window.location.href });
  
          if(data && data.length){
            seTActiveLink(data && data[0].enabled);
            localStorage.setItem("needLogin", true);
          }
       
      } 
      else if(client){
        const { data, error } = await supabase
          .from("board_clients_invitation")
          .select("*")
          .match({ url_with_token: client });
  
          if(data && data.length){
            seTActiveLink(data && data[0].enabled);
            localStorage.setItem("needLogin", true);
          }
      }
      else if (board_id && !token && window.location.pathname != "/boardDetails") {
        var { data, error } = await supabase
        .from("board_profiles")
        .select("*")
        .match({ board: board_id });

        let publicClient = data;
        let isAdmin = localStorage.getItem('admin')
        if(email && !isAdmin){
          var { data, error } = await supabase
          .from("board_clients_invitation")
          .select("*")
          .match({ board: board_id, email: email});
  
          if(data && data.length > 0){
            setRedirectUrl(data[0].url_with_token);
            seTActiveLink(data[0].enabled);
          }
          else{
            sendInvitation(board_id,email,publicClient);
          }
        }
        else{
          if(publicClient && publicClient.length > 0){
            seTActiveLink(publicClient[0].activeLink);
          }
        }
      
      }
      
    }
  
    setRenderFlag(true);

  },[]);

  const sendInvitation = async(board_id,email,publicClient) => {
    var c_url = createUrl(board_id);

    insertEmail(email,c_url,board_id,publicClient);
    let clientName = email;

    // handleClose();
    if(publicClient && publicClient.length > 0){
      sendEmailNotification(`<div>
      <div style="padding-top:25px">
          <img src="https://yourimageshare.com/ib/ImZrKL2FsS.png" alt="GaperLogo here" height="10%" width="20%" />
      </div>
      <div style="padding:15px 50px">
      <p style=" font-size: 17px;  font-family: 'Poppins', sans-serif; margin: 0px;">Hi ${clientName},</p>
      <p style=" font-size: 16px; font-family: 'Poppins', sans-serif; margin: 0px; padding-top: 3px;">We have customised a team of engineer specific for you.</p>
      <div style="margin-top:20px; font-family: 'Poppins', sans-serif; text-align: center;  position:relative;">
          <div style="padding:40px 0px; border:0.9px solid #C8C8C8; border-radius:10px;">
          <a href='${c_url}'>
          <img src="${publicClient[0].profiles_screenshot}" height="40%" width="90%" alt="ScreenShot Image here" /> </a>
          </div>
          <br />
          <div style="text-align: center;">
          <a href='${c_url}'>
            <button style="background-color: #0C60FF; color:#fff; height:42px; width:170px; border-radius: 4px; border: none; font-size: 18px; font-family: 'Inter', sans-serif; text-align: center;"><a style="color:#fff; text-decoration: none;">View list </a>
            </button>
          </a>
          </div>
          <p style="font-family: 'Poppins', sans-serif; font-size: 16px;">This list is valid for 10 days, Hope to see you soon.</p>
      </div>
      </div>
      </div>`,email);

    }

    seTActiveLink(true);
  };

  const createUrl = (board_id) => {
    var Id = nanoid();
    var boardId = Buffer.from(board_id, "utf-8").toString("base64");

    var newId = boardId.concat("/", Id);
    var str = `${window.location.origin}/client?id=`;
    var newUrl = str.concat(newId);

    return newUrl;
  };

  const insertEmail = async (userEmail, c_url, boardId,publicClient) => {
      if(publicClient && publicClient.length > 0){
        let profiles = publicClient[0].profiles;
        var dashboard_id ="";

        var { data, error } = await supabase
        .from("board_clients_invitation")
        .select("*")
        .match({ email: userEmail});

        if(data && data.length){
          dashboard_id = data[0].dashboard_id;
        }
  
        var res = await supabase
          .from("board_clients_invitation")
          .insert([
            {
              email: userEmail,
              expireDate: 10,
              profiles: profiles,
              board: boardId,
              url_with_token: c_url,
              dashboard_id: dashboard_id ? dashboard_id : nanoid()
            },
          ]);

        if(res && res.data.length > 0){
          setRedirectUrl(c_url);
        }
      }
    
  };

  async function sendEmailNotification(message,email) {
    //Setting email template params
    var templateParams = {
      message: message,
      email: "supply@gaper.io",
      to: email,
    };

    //Sending email
    axios
      .post(
        // "http://localhost:5000/sendEmail",
        "https://gaper-email-service.herokuapp.com/sendEmail",
        templateParams,
        {
          headers: { key: "1eb2cy567keyoipaex-assqwe12" },
        }
      )
      .then(function (response) {})
      .catch(function (error) {});
  }

  if (renderFlag) {
      var userToken = localStorage.getItem("supabase.auth.token");
      if((localStorage.getItem("clientUrl") || localStorage.getItem("publicClientUrl")) && (url?.pathname =="/" || url?.pathname =="/search" || url?.pathname =="/board" || url?.pathname =="/details") && localStorage.getItem("admin") != "true"){
        return window.history.back()
      }
      else if (activeLink && redirectUrl) {
        return window.open(redirectUrl , "_self")
       
      }
      else if (activeLink && !redirectUrl) {
        return children;
      }
      else if (!activeLink && boardId && window.location.pathname != "/boardDetails" && window.location.pathname != "/board") {
        return <Navigate to="/notfound" />;
      }
      else {
        return userToken ? children : <Navigate to="/login" />;
      }
    }
  else{
      return null;
  }
}
